import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { AppSettings } from '../../helpers/config';
//import { AuthenticationService } from '../auth/authentication.service';

import { User } from '../../models/user';

@Injectable()
export class MainService {
    public AppSettings = new AppSettings;
    public usuario: User[] = []; 
   
    constructor(private http: HttpClient) { }

    getUsers(): Observable<any> {
        return this.http.get<User[]>( this.AppSettings.URL + 'main/getuser' )
            .pipe(
                catchError(this.handleError('getUsers', []))
            );
    }
    /**
    * Handle Http operation that failed.
    * Let the app continue.
    * @param operation - name of the operation that failed
    * @param result - optional value to return as the observable result
    */
    private handleError<T> (operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

        // TODO: send the error to remote logging infrastructure
        console.error(error); // log to console instead

        // TODO: better job of transforming error for user consumption
        this.log(`${operation} failed: ${error.message}`);

        // Let the app keep running by returning an empty result.
        return of(result as T);
        };
    }
    private log(message: string) {
        console.log(message);
    }
}



// WEBPACK FOOTER //
// /home/estandar/web/tuhogaronline.tk/public_html/adminTHO/src/app/components/main/main.service.ts